import { Box, Paper } from '@material-ui/core';
import clsx from 'clsx';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { getTask, getTaskResponseList } from '../../api/task';
import { ApiContext } from '../../contexts/ApiContext';
import { AuthContext } from '../../contexts/AuthContext';
import { mainishStyles } from '../../styling';
import { useSnackBar } from '../Common/SnackBarContext';
import StageTask from '../Common/Task/StageTask';

const displayTaskUI = (taskResponse) => {
  return <StageTask response={taskResponse} />;
};

export default function UpdateTasks() {
  const mainishclasses = mainishStyles();
  const apiContext = useContext(ApiContext);
  const authContext = useContext(AuthContext);
  const [tasksResponses, setTaskresponses] = useState([]);

  const snackBarHelper = useSnackBar();
  const getTaskRespFunc = useCallback(async (ticketId) => {
    try {
      const res = await getTaskResponseList(apiContext.axios, ticketId);
      setTaskresponses(res.data);
    } catch (e) {
      snackBarHelper.openSnackBar('error', String(e));
    }
  }, []);

  useEffect(async () => {
    if (authContext?.authenticated && authContext?.auth) {
      const id = authContext?.auth;
      await getTaskRespFunc(id);
    }
  }, [getTask]);

  return (
    <>
      {tasksResponses.map((taskResponse, i) => (
        <Paper
          className={clsx(
            mainishclasses.pageContent,
            mainishclasses.formCommons
          )}
          key={i}
        >
          <Box>{displayTaskUI(taskResponse)}</Box>
        </Paper>
      ))}
    </>
  );
}
